import EventDatatable from "./event_datatable_controller";

// Connects to data-controller="home-upcoming-event-datatable"
export default class extends EventDatatable {
  get pageLength() {
    return 4;
  }
}
